<template>
  <div class="modal__bike-wrapper">
    <div v-if="descriptionTop" class="modal__description" v-html="descriptionTop"></div>
    <div
      class="modal__bike-content"
    >
      <div class="modal__bike-row">
        <div class="modal__bike-label">
          <translated-text-component translation="bike_spaces_available" />:
        </div>
        <div class="modal__bike-amount">
          <i class="mdi mdi-bicycle"></i>
          {{totalBikeSpots}}
        </div>
      </div>
      <div v-if="availableBikes >= 0" class="modal__bike-row">
        <div class="modal__bike-label">
          <translated-text-component translation="bike_available_label" />:
        </div>
        <div class="modal__bike-amount" :class="availableBikes < 1 ? '--full' : '--free'">
          <i class="mdi mdi-bicycle"></i>
          {{availableBikes}}
        </div>
      </div>
      <div v-if="safetyLockBikes >= 0" class="modal__bike-row">
        <div class="modal__bike-label">
          <translated-text-component translation="bike_safety_lock" />:
        </div>
        <div class="modal__bike-amount">
          <i class="mdi mdi-lock"></i>
          {{safetyLockBikes}}
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import {
  computed,
  defineComponent, onMounted, Ref, ref, watch,
} from 'vue';
import ModalTemplateService from '@/services/ModalTemplateService';
import store from '@/store/index';
import { IModalData } from '@/services/layers/IModalData';

const TemplateModalBikeStation: object = defineComponent({
  props: {
    templateData: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    const modalData: Ref<IModalData|null> = ref(null);
    const totalBikeSpots: Ref<number|undefined> = ref();
    const availableBikes: Ref<number|undefined> = ref();
    const safetyLockBikes: Ref<number|undefined> = ref();
    const descriptionTop = ref('');

    onMounted(() => {
      const { metaData } = props.templateData;
      modalData.value = metaData;
      descriptionTop.value = metaData.description;
      totalBikeSpots.value = metaData.totalBikeSpots;

      if(metaData.lastStatus) {
        availableBikes.value = metaData.lastStatus.availableBikes;
        safetyLockBikes.value = metaData.lastStatus.safetyLockBikes;
      }
    });

    return {
      modalData,
      descriptionTop,
      totalBikeSpots,
      availableBikes,
      safetyLockBikes,
    };
  },
});
export default TemplateModalBikeStation;
</script>

<style lang="scss">
.modal__bike {
  &-wrapper {
    text-align: center;
  }

  &-label {
    margin-bottom: 10px;
    font-weight: 700;
  }

  &-row {
    margin-bottom: 6px;
  }

  &-amount {
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 800;
    // color: $tab-bg-bike;

    i {
      font-size: rem(32px);
      margin-right: 11px;
    }

    &.--full {
      color: $modal-parking_full_icon;
    }

    &.--free {
      color: $modal-parking_free_icon;
    }
  }
}
</style>

